import { ID } from "common/entities/IEntity";
import { Entity, Field } from "typegraph";

export enum Lifecycle {Draft, Published, Deleted}

@Entity({
	one: "testAssignment",
	many: "testAssignments"
})
export class TestAssignment {
    @Field()
    public id: ID;

    @Field()
    public institutionId: String;
    
    @Field()
	public institutionName: string;

    @Field()
    public programId: ID;
    
    @Field()
	public programName: string;

    @Field()
	public name: string;

    @Field()
	public description: string;

    @Field()
	public startDate: string;

    @Field()
	public dueDate: string;

    @Field()
	public totalEnrollment: number;

    @Field()
	public totalCompletion: number;

    @Field()
	public testId: number;

    @Field()
    public assignmentStatus: number;
    
}


// WEBPACK FOOTER //
// ./src/panels/testAssignment/entities/TestAssignment.ts